import React, { ReactNode } from 'react';

export type TableProps = {
  children: ReactNode;
};
export const Table: React.FC<TableProps> = ({ children }: TableProps) => {
  return <table className="text-grey-700 w-full">{children}</table>;
};
